import { Link } from 'react-router-dom';

const servicesLinks = [
	{ label: 'Services', href: '#services' },
	{ label: 'Mobile App Development', href: '#services' },
	{ label: 'Website Development', href: '#services' },
	{ label: 'Database Management', href: '#services' },
];

const legalLinks = [
	{ label: 'Privacy Policy', to: '/privacy' },
	{ label: 'Terms of Service', to: '/terms' },
	{ label: 'Cookie Policy', to: '/cookie-policy' },
	{ label: 'Data Deletion', to: '/data-deletion' },
];

const socialLinks = [
	{ label: 'Facebook', href: '#', icon: '📘' },
	{ label: 'Twitter', href: '#', icon: '🐦' },
	{ label: 'LinkedIn', href: '#', icon: '💼' },
	{ label: 'Instagram', href: '#', icon: '📸' },
];

function Footer() {
	return (
		<footer className="mt-12 bg-slate-950 text-white">
			<div className="mx-auto max-w-7xl px-6 py-14 sm:px-8 lg:px-8">
				<div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
					<div>
						<h3 className="text-xl font-bold text-white">VIANCE HEALTHCARE SYSTEMS PRIVATE LIMITED</h3>
						<p className="mt-3 text-sm leading-relaxed text-blue-100">
							Technology solutions company delivering mobile apps, websites, and database
							management for healthcare systems and modern service businesses.
						</p>
					</div>

					<div>
						<h4 className="text-sm font-semibold uppercase tracking-wide text-cyan-300">About</h4>
						<ul className="mt-4 space-y-2 text-sm text-slate-300">
							<li className="font-medium text-white">Directors: Nimisha Sharma | Meenal Sharma</li>
							<li>Email: csnimishasharma@gmail.com</li>
							<li>Phone: 9823272353</li>
						</ul>
					</div>

					<div>
						<h4 className="text-sm font-semibold uppercase tracking-wide text-cyan-300">Services</h4>
						<ul className="mt-4 space-y-2 text-sm text-slate-300">
							{servicesLinks.map((item) => (
								<li key={item.label}>
									<a className="transition duration-300 hover:text-cyan-300" href={item.href}>
										{item.label}
									</a>
								</li>
							))}
						</ul>
					</div>

					<div>
						<h4 className="text-sm font-semibold uppercase tracking-wide text-cyan-300">Legal</h4>
						<ul className="mt-4 space-y-2 text-sm text-slate-300">
							{legalLinks.map((item) => (
								<li key={item.label}>
									<Link className="transition duration-300 hover:text-cyan-300" to={item.to}>
										{item.label}
									</Link>
								</li>
							))}
						</ul>
					</div>

					<div>
						<h4 className="text-sm font-semibold uppercase tracking-wide text-cyan-300">Contact</h4>
						<ul className="mt-4 space-y-2 text-sm text-slate-300">
							<li>admin@viance.co.in</li>
							<li>9823272353</li>
							<li>Sulochana Apartments, Income Tax Lane, Pune - 411004</li>
						</ul>
					</div>
				</div>

				<div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-slate-700 pt-6 sm:flex-row sm:items-center">
					<p className="text-xs text-slate-400">
						© 2026 VIANCE HEALTHCARE SYSTEMS PRIVATE LIMITED. All rights reserved.
					</p>

					<div className="flex items-center gap-2">
						{socialLinks.map((item) => (
							<a
								key={item.label}
								href={item.href}
								aria-label={item.label}
								className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-700 bg-slate-900 text-sm text-white transition duration-300 hover:border-cyan-400 hover:text-cyan-300"
							>
								<span aria-hidden="true">{item.icon}</span>
							</a>
						))}
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
